(function () {
    'use strict';

    angular.module('iMatApp')
        .controller('ProductDesignerController', ProductDesignerController);

    ProductDesignerController.$inject = ['$scope', '$log', 'workflow', 'workspace', 'pricingService', 'productIssueTrackEventService'];

    function ProductDesignerController($scope, $log, workflow, workspace, pricingService, productIssueTrackEventService) {
        var vm = this;

        vm.workspace = workspace;

        vm.setup = setup;
        vm.cancelProcessing = cancelProcessing;
        vm.hasFreeSlots = hasFreeSlots;
        vm.duplicate = duplicate;
        vm.applyToAll = applyToAll;
        vm.getModelProcessingStatusTransKey = getModelProcessingStatusTransKey;
        vm.formatUnavailableMoney = pricingService.formatUnavailableMoney;
        vm.get3DLabUrl = get3DLabUrl;
        vm.getMaterialInfoUrl = getMaterialInfoUrl;
        vm.getColourUrl = getColourUrl;

        // -------------------------------------------------------------
        function setup(product) {
            product.onPropertiesChanged($scope, productPropertiesChanged);
            productIssueTrackEventService.runProductIssueWatching($scope, product);
        }

        function productPropertiesChanged(product) {
            workflow.recalculateProductPrice(product.id);
        }

        function cancelProcessing(product) {
            workflow.cancelProductProcessing(product.id);
        }

        function hasFreeSlots() {
            return workflow.hasFreeSlots();
        }

        function duplicate(product) {
            workflow.duplicate(product.id);
        }

        function applyToAll(product) {
            workflow.applyToAll(product.id);
        }

        function getModelProcessingStatusTransKey(status) {
            if (!status || status.isUnknown()) {
                return 'multiple-upload_model-processing-status-analyzing';
            }

            var statusKey = status.name.toLowerCase();

            return 'multiple-upload_model-processing-status-' + statusKey;
        }

        function get3DLabUrl(product) {
            return "/" + workspace.settings.languageCode
                + "/3dprint#modelId=" + product.model.id
                + "&materialId=" + product.material().id
                + "&colourId=" + product.colour().id
                + "&scale=" + product.scale()
                + "&quantity=" + product.quantity();
        }

        function getMaterialInfoUrl(material) {

            if (!material || !material.urlFriendlyName) {
                return null;
            }

            return vm.workspace.settings.materialPageUrl.replace('PLACEHOLDER', material.urlFriendlyName);
        }

        function getColourUrl(material) {

            if (!material || !material.urlFriendlyName) {
                return null;
            }

            return vm.workspace.settings.materialColorsAndFinishesUrl.replace('PLACEHOLDER', material.urlFriendlyName);
        }
    }
})();